import React, { useState, useEffect } from "react";
import s from "../../admin_styles/UserSearch.module.css";
import UserCardList from "./UserCardList";
import UserTableList from "./UserTableList";
import Pagination from "./Pagination";
import MassActions from "./MassActions";


// Список доступных полей для сортировки с русскими названиями
const sortOptions = [
  { value: "id", label: "ID" },
  { value: "login", label: "Логин" },
  { value: "name", label: "Имя" },
  { value: "tgnikname", label: "TG ник" },
  { value: "tg_name", label: "Имя TG" },
  { value: "tg_user_id", label: "ID TG" },
  { value: "reg_date", label: "Дата регистрации" }
];

export default function UserSearch() {
  const [query, setQuery] = useState("");
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [sortBy, setSortBy] = useState("id");
  const [sortOrder, setSortOrder] = useState("desc");
  const [onlyVip, setOnlyVip] = useState("");
  const [rangeText, setRangeText] = useState("");
  const [pageSize, setPageSize] = useState(50);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await fetch("/api/admin/search_users", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ query, page, page_size: pageSize, sort_by: sortBy, sort_order: sortOrder, onlyvip:onlyVip })
      });

      const result = await res.json();
      setUsers(result.users);
      setRangeText(result.range_text);

      const total = result.total || 0;
      setTotalPages(Math.ceil(total / pageSize));
    } catch (err) {
      console.error("Ошибка запроса:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [page, sortBy, sortOrder, onlyVip, pageSize]);

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    fetchUsers();
  };

  const handleSortChange = (e) => {
    setSortBy(e.target.value);
    setPage(1);
  };

  const handleOrderChange = (e) => {
    setSortOrder(e.target.checked ? "desc" : "asc");
    setPage(1);
  };

  const handleonlyvipChange = (e) => {
    setOnlyVip(e.target.checked ? "1" : "");
    setPage(1);
  };

  return (
    <div className={s.wrapper}>
      <form onSubmit={handleSearch} className={s.searchBar}>
        <input
          type="text"
          value={query || ""}
            name="search_admin_five_ads"
            autoComplete="on"
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Поиск по пользователям или ID проекта"
        />
        <button type="submit">Поиск</button>

        <div className={s.sortControls}>
          <label>
            Сортировать по:{" "}
            <select value={sortBy} onChange={handleSortChange}>
              {sortOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </label>
          <label style={{ marginLeft: "10px" }}>
              На странице:{" "}
              <select value={pageSize} onChange={(e) => {
                setPageSize(Number(e.target.value));
                setPage(1); // возвращаемся на первую страницу
              }}>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={200}>200</option>
                <option value={500}>500</option>
              </select>
            </label>

          <label style={{ marginLeft: "10px" }}>
            <input
              type="checkbox"
              checked={sortOrder === "desc"}
              onChange={handleOrderChange}
            />{" "}
            Обратный порядок
          </label>

          <label style={{ marginLeft: "10px" }}>
            <input
              type="checkbox"
              checked={onlyVip === "1"}
              onChange={handleonlyvipChange}
            />{" "}
            vip
          </label>
        </div>
      </form>

      <Pagination page={page} totalPages={totalPages} onPageChange={setPage} totaltext={rangeText} />

      {loading ? (
        <p>Загрузка...</p>
      ) : (
        // <UserCardList users={users} />
        <>
        <MassActions selectedUsers={selectedUsers} />
        <UserTableList
          users={users}
          setUsers={setUsers}
          selectedUsers={selectedUsers}
          setSelectedUsers={setSelectedUsers}
        />

        </>
    
      )}

      <Pagination page={page} totalPages={totalPages} onPageChange={setPage} totaltext={rangeText} />
    </div>
  );
}
